var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.364,
    height: 29.736,
    viewBox: "0 0 32.364 29.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-836.824 -579.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.189,651.13a9.3,9.3,0,0,0-6.343,2.5,9.328,9.328,0,0,0-15.682,6.84c0,12.176,15.682,19.348,15.682,19.348s15.682-7.171,15.682-19.348A9.338,9.338,0,0,0,886.189,651.13Z",
    transform: "translate(-26.84 -71.57)",
    fill: "none",
    stroke: "#af995c",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorites);
export default __webpack_public_path__ + "static/media/icon_favorites.f43560061a245bb01311a82ced03b61b.svg";
export { ForwardRef as ReactComponent };